export default "__VITE_ASSET__CBKsibPF__"